module.exports = __webpack_public_path__ + "img/Diversified.04f200d1.svg";